// 折线 line
export const lineDefault = {
  lineColor: '#5b8ff9',
  lineSize: 2
}

export const lineConfig = [
  { title: '折线颜色', name: 'lineColor', type: 'color' },
  { title: '折线宽度', name: 'lineSize', type: 'number' }
]

export function calcLineData(options) {
  const calcData = {
    color: options.lineColor,
    size: options.lineSize
  }
  return calcData
}

// 面积 area
export const areaDefault = {
  areaStyleFill: '#5E85D5',
  areaStyleStroke: 'transparent',
  areaStyleLineWidth: 0
}

export const areaConfig = [
  { title: '面积填充色', name: 'areaStyleFill', type: 'color' }
  // { title: '面积描边色', name: 'areaStyleStroke', type: 'color' },
  // { title: '面积描边宽度', name: 'areaStyleLineWidth', type: 'number' }
]

export function calcAreaStyleData(options) {
  const calcData = {
    fill: options.areaStyleFill
    // stroke: options.areaStyleStroke,
    // lineWidth: options.areaStyleLineWidth
  }
  return calcData
}

// 数据点
export const pointDefault = {
  pointStyleFill: '#5E85D5',
  pointShape: 'square',
  pointSize: 1
}

export const pointConfig = [
  { title: '面积填充色', name: 'areaStyleFill', type: 'color' }
  // { title: '面积描边色', name: 'areaStyleStroke', type: 'color' },
  // { title: '面积描边宽度', name: 'areaStyleLineWidth', type: 'number' }
]

export function calcPointData(options) {
  const calcData = {
    shape: options.pointShape,
    size: options.pointSize,
    style: {
      fill: options.pointStyleFill,
      stroke: options.pointStyleStroke,
      lineWidth: options.pointStyleLineWidth
    }
  }
  return calcData
}
